import { Link } from 'react-router-dom';
import { useProducts } from '../hooks/useProducts';
import Spinner from '../components/Spinner';
import EmptyState from '../components/EmptyState';
import emptyProductsImage from '../assets/empty-products.png';
import { colors, primaryButtonStyle, mintButtonStyle, lavenderButtonStyle } from '../lib/theme';

export default function Products() {
  const { products, loading, archiveProduct } = useProducts();

  if (loading) return <Spinner label="Loading products…" />;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h2>Products</h2>
        <Link to="/products/new">
          <button style={primaryButtonStyle}>+ Add product</button>
        </Link>
      </div>
      {products.length === 0 ? (
        <EmptyState image={emptyProductsImage} alt="No products yet" />
      ) : (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {products.map((product) => (
          <div
            key={product.id}
            style={{
              background: colors.blue,
              color: colors.blueText,
              borderRadius: 14,
              padding: '0.75rem 1rem',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            <div>
              <div style={{ fontWeight: 700 }}>{product.name}</div>
              <div style={{ fontSize: '0.85rem', opacity: 0.75 }}>
                {product.caloriesPer100g} kcal/100g
                {product.proteinPer100g != null ? ` · ${product.proteinPer100g}g protein` : ''}
                {product.fatPer100g != null ? ` · ${product.fatPer100g}g fat` : ''}
                {product.carbsPer100g != null ? ` · ${product.carbsPer100g}g carbs` : ''}
                {product.category ? ` · ${product.category}` : ''}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexShrink: 0 }}>
              <Link to={`/products/${product.id}/edit`}>
                <button style={lavenderButtonStyle}>Edit</button>
              </Link>
              <button style={mintButtonStyle} onClick={() => archiveProduct(product.id)}>
                Archive
              </button>
            </div>
          </div>
        ))}
      </div>
      )}
    </div>
  );
}
